import { NgModule, PLATFORM_ID } from '@angular/core';
import {CommonModule, DatePipe} from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CustomFormsModule } from 'ng2-validation'; // TODO import core module instead ?
import { RouterModule, Routes } from '@angular/router';

import { LoginComponent } from './login/login.component';
import { LoginFormComponent } from './login/login-form/login-form.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { SignupFormComponent } from './login/signup-form/signup-form.component';
import { ResetFormComponent } from './login/reset-form/reset-form.component';
import { PasswordComponent } from './login/password/password.component';
import {AssetPipe} from "../fo/home/image.pipe";
import {DateFPipe} from "../fo/home/date.pipe";
import {Participants} from "../bo/events/participants.pipe";
import {Recettes} from "../bo/events/recette.pipe";
import {StatutPipe} from "../bo/events/eventStatus.pipe";
import {HourPipe} from "../fo/home/hour.pipe";
import {SafePipe} from "../fo/safe.pipe";
import {HttpClient, HttpClientModule} from "@angular/common/http";
import {TranslateLoader, TranslateModule, TranslatePipe, TranslateService} from "@ngx-translate/core";

import {TranslateHttpLoader} from "@ngx-translate/http-loader";

import { TranslateUniversalLoader } from "./universal-translate-loader";
import {BrowserTransferStateModule, TransferState} from "@angular/platform-browser";
import { isPlatformServer } from "@angular/common";
import {Participations} from "../bo/admin/admin-users/participations.pipe";
import {CommissionPipe} from "../bo/events/commission.pipe";
import {ContactComponent} from "../fo/page/contact/contact.component";
import {Ng2TelInputModule} from "ng2-tel-input";
import {DateFPipe2} from "../fo/home/date2.pipe";
import {DateFPipe1} from "../fo/home/date1.pipe";
import {PaiementModuleComponent} from "./paiement-module/paiement-module.component";
import {UsersService} from "../bo/users/users.service";
import {EventsService} from "../bo/events/events.service";
import {OrganizationService} from "../bo/organization/organization.service";
import {FonctionUtiles} from "../utils/fonctionsUtiles";
import {PaymentService} from "./services/payment.service";
import {NgxMaskModule} from "ngx-mask";
import {LoadingComponentComponent} from "./loading-component/loading-component.component";
import {PaymentDataFormComponent} from "../fo/account/profile/payment-data-form/payment-data-form.component";
import {DatePipeFr} from "../fo/home/dateFr.pipe";
import {SharedRoutingModule} from "./shared-routing.module";
import {translateBrowserLoaderFactory} from "../translate-browser.loader";
import {NgtUniversalModule} from "@ng-toolkit/universal";
import {AuthService} from "../core/auth/auth.service";
import {TransferHttpCacheModule} from "@nguniversal/common";
import {CoreModule} from "../core/core.module";
import {ImageCropperModule} from "ngx-image-cropper";
import {ToastrModule} from "ngx-toastr";
import {BaseComponent} from "./components/base/base.component";
import { HttpReQuestLoaderComponent } from './components/http-re-quest-loader/http-re-quest-loader.component';
import {
  FacebookLoginProvider,
  GoogleLoginProvider,
  SocialAuthServiceConfig,
  SocialLoginModule
} from "@abacritt/angularx-social-login";
import {LastActivePageService} from "./services/last-active-page.service";



@NgModule({
    imports: [
        ImageCropperModule,
        CoreModule,
        TranslateModule,
        SharedRoutingModule,
        CommonModule,
        FormsModule,
        TransferHttpCacheModule,
        CustomFormsModule,
        RouterModule,
        Ng2TelInputModule,
        NgtUniversalModule,
        TranslateModule.forRoot({
            defaultLanguage: 'fr',
            loader: {
                provide: TranslateLoader,
                useFactory: translateBrowserLoaderFactory,
                deps: [HttpClient, TransferState]
            }
        }),
        NgxMaskModule.forRoot(),// ToastrModule added

    ],
  providers: [
    PaymentService,FonctionUtiles,AuthService,OrganizationService,LastActivePageService

  ],
  declarations: [
    BaseComponent,
    LoginComponent,
    LoginFormComponent,
    NotFoundComponent,
    SignupFormComponent,
    ResetFormComponent,
    PasswordComponent,
    PaiementModuleComponent,
    AssetPipe,
    DateFPipe,
    DateFPipe1,
    DateFPipe2,
    DatePipeFr,
    HourPipe,
    Participants,
    Participations,
    Recettes,
    StatutPipe,
    SafePipe,
    CommissionPipe,
    ContactComponent,
    LoadingComponentComponent,
    PaymentDataFormComponent,
    HttpReQuestLoaderComponent,
  ],

  exports: [
    ImageCropperModule,
    TranslateModule,
    LoginComponent,
   LoginFormComponent,
   SignupFormComponent,
   ResetFormComponent,
   PasswordComponent,
   AssetPipe,
   HourPipe,
   DateFPipe,
   DateFPipe1,
   DateFPipe2,
   DatePipeFr,
   Participants,
   Recettes,
   StatutPipe,
  SafePipe,
  TranslatePipe,
  Participations,
  CommissionPipe,
  ContactComponent,
    Ng2TelInputModule,
  PaiementModuleComponent,
    LoadingComponentComponent,
    PaymentDataFormComponent,
    TransferHttpCacheModule,
    HttpReQuestLoaderComponent,
    BaseComponent
  ]

})
export class SharedModule {
/*  constructor(private translate: TranslateService) {
    translate.addLangs(['fr', 'en']);
    translate.setDefaultLang('fr');
    translate.use('fr');
  }*/
}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
